(function () {
  function replaceButtonText(button, text) {
    if (!button) return;

    var textNode = Array.prototype.find.call(button.childNodes, function (node) {
      return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
    });

    if (textNode) {
      textNode.textContent = text;
    } else {
      button.appendChild(document.createTextNode(text));
    }

    button.setAttribute('aria-label', text);
  }

  function enhanceHomepage() {
    var availability = document.querySelector('.ca-avail');
    if (!availability) return;

    availability.id = 'ca-availability';

    if (!availability.querySelector('.ca-mobile-rating')) {
      var mobileRating = document.createElement('a');
      mobileRating.className = 'ca-mobile-rating';
      mobileRating.href = 'https://maps.app.goo.gl/6yiKy3ctfaEAXYqg8';
      mobileRating.target = '_blank';
      mobileRating.rel = 'noopener';
      mobileRating.setAttribute('aria-label', 'Read Chapin Adventures reviews on Google');
      mobileRating.innerHTML = '<span class="ca-mobile-rating__stars" aria-hidden="true">★★★★★</span><span><strong>5.0</strong> on Google</span>';
      availability.appendChild(mobileRating);
    }

    var fields = availability.querySelectorAll('.fld');
    var fieldIds = ['ca-location', 'ca-dt', 'ca-rt'];
    Array.prototype.forEach.call(fields, function (field, index) {
      var label = field.querySelector('label');
      var control = field.querySelector('select, input');
      if (!label || !control || !fieldIds[index]) return;
      control.id = fieldIds[index];
      label.setAttribute('for', fieldIds[index]);
    });

    var heroButton = document.querySelector('.ca-hero__btn--y');
    if (heroButton) {
      heroButton.setAttribute('href', '#ca-availability');
      replaceButtonText(heroButton, 'Check Availability');
    }

    var pricingButton = document.querySelector('.wkb__b');
    if (pricingButton) {
      pricingButton.setAttribute('href', '#ca-availability');
      replaceButtonText(pricingButton, 'Check Availability');
    }

    var pricingHeading = document.querySelector('.wkb__h');
    if (pricingHeading) {
      pricingHeading.innerHTML = 'Simple pricing. <span class="hl">Same for every rental.</span>';
    }

    var pricingIntro = document.querySelector('.wkb__p');
    if (pricingIntro) {
      pricingIntro.textContent = 'Rent for a day or keep it for up to seven days. All gear is included, with no hidden fees.';
    }

    var priceLabels = document.querySelectorAll('.wkb__c .lab');
    if (priceLabels.length === 3) {
      priceLabels[0].textContent = 'First day';
      priceLabels[1].textContent = 'Each extra day';
      priceLabels[2].textContent = 'Up to 7 days';
    }

    var pricingFinePrint = document.querySelector('.wkb__fine');
    if (pricingFinePrint) {
      pricingFinePrint.textContent = 'The meter stops at $160—about $23 a day for seven days.';
    }

    var cards = document.querySelectorAll('.ca-fc');
    Array.prototype.forEach.call(cards, function (card) {
      var title = card.querySelector('.ca-fc__t');
      var button = card.querySelector('.ca-fc__btn');
      if (!title || !button) return;

      if (!card.querySelector('.ca-fc__price-summary')) {
        var summary = document.createElement('p');
        summary.className = 'ca-fc__price-summary';
        summary.innerHTML = '<strong>$60/day</strong> &middot; 7-day price capped at <strong>$160</strong>';
        button.parentNode.insertBefore(summary, button);
      }

      var buttonLabels = {
        'Paddle Board (SUP)': 'Book a Paddle Board',
        'Double Kayak': 'Book a Double Kayak',
        'Single Kayak': 'Book a Single Kayak'
      };
      replaceButtonText(button, buttonLabels[title.textContent.trim()] || 'Book This Rental');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceHomepage);
  } else {
    enhanceHomepage();
  }
})();
